/**
 * Narrative agent for story generation.
 *
 * Generates immersive prose narrative in a dark DOS-era voice.
 * Uses "pro" tier models for maximum coherence and context retention.
 */

import type { StreamChunk, ProviderConfig, TaskType } from "../types";
import { BaseAgent } from "./base";
import { dispatchStream } from "./providers";
import { narrativeSystemPrompt } from "../prompts/narrative";

/** Narrative agent: generates story text, descriptions, and dialogue. */
export class NarrativeAgent extends BaseAgent {
  readonly taskType: TaskType = "narrative";

  constructor(config: ProviderConfig, maxTokens = 2048, temperature = 0.7) {
    super(config, maxTokens, temperature);
  }

  async *stream(prompt: string, context?: string): AsyncGenerator<StreamChunk, void, unknown> {
    const systemPrompt = narrativeSystemPrompt();
    const userPrompt = this.buildPrompt(prompt, context);

    yield* dispatchStream({
      config: this.config,
      systemPrompt,
      userPrompt,
      maxTokens: this.maxTokens,
      temperature: this.temperature,
      tier: "pro",
      modelId: this.currentModelId,
    });
  }
}
